export const WIDTH = 10;
export const HEIGHT = 20 + 1; // 1 for slack on roatate at topmost line.
export const PREDICTABLE_RANDOM = true;
export const ENABLE_REDUX_LOGGER = false;
export const ENABLE_SAGA_MONITOR = false;
export const LINES_SCORE = [0, 40, 100, 300, 1200];



// WEBPACK FOOTER //
// ./src/game/config.js